import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash-es';
import { MenuItem } from 'primeng/api';
import { SubSink } from 'subsink';
import { AccountService } from '../services/account.service';
import { AuthenticationService } from '../services/authentication.service';
import { LoggingService } from '../services/logging.service';
import { AddAccountViewModel, UpdateAccountViewModel, UpdatePasswordViewModel } from '../shared/models/update-account-view-model';
import { ToastService } from '../shared/toast/toast.service';

@Component({
  selector: 'pps-add-user',
  templateUrl: './add-user.component.html',
  styles: [
  ],
})
export class AddUserComponent implements OnDestroy {
  private subs = new SubSink();

  items: MenuItem[] = [
    {label: "Admin", icon: "pi-fw fas fa-user-cog"},
    {label: "Manage Users", icon: "pi-fw fas fa-users", routerLink: ["/manage-user"]},
    {label: "Add New User", icon: "pi-fw fas fa-user-plus"},
  ];

  newAccountViewModel: AddAccountViewModel = new AddAccountViewModel();
  section: string = "profile";
  updating: boolean = false;
  errorMessage: string = "";
  accountCreated: boolean = false;
  smallScreen: boolean = false;

  constructor(private _accountService: AccountService,
              private _toast: ToastService,
              private _router: Router,
              private breakpointObserver: BreakpointObserver) {
    this.subs.sink = this.breakpointObserver.observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.smallScreen = !state.matches;
      });    
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  addUserAccount(userForm){
    if (this.newAccountViewModel.newPassword !== this.newAccountViewModel.confirmPassword){
      userForm.controls["confirmPassword"].setErrors({"notmatch": true});
      return;
    }

    if (this.newAccountViewModel.newPassword){
      if (!/(?=.*[a-z])/g.test(this.newAccountViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nolowercase": true});
        return;
      }

      if (!/(?=.*[A-Z])/g.test(this.newAccountViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nouppercase": true});
        return;
      }

      if (!/(?=.*\d)/g.test(this.newAccountViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nodigit": true});
        return;
      }

      if (!/(?=.*[-+_!@#$%^&*.,?])/g.test(this.newAccountViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nonalphanumeric": true});
        return;
      }
    }

    if (userForm.invalid){
      return;
    }

    this.updating = true;
    this.accountCreated = false;
    
    let newAcct = _.clone(this.newAccountViewModel);
    newAcct.newPassword = btoa(this.newAccountViewModel.newPassword);
    newAcct.confirmPassword = btoa(this.newAccountViewModel.confirmPassword);
    this.subs.sink = this._accountService.add(newAcct)
      .subscribe(res => {
        if (res.succeed){
          this.accountCreated = true;
          this._toast.succeeded("New account has been created.");
        }else{
          this._toast.failed(`Failed to create new account`);
        }
      })
      .add(()=>{
        this.updating = false;
      });;
  }

  returnToUserManagement(){
    this._router.navigate(["/manage-user"], {replaceUrl: true});
  }

  gotoUserRoleManagement(){
    this._router.navigate(["/user-role-management"], {replaceUrl: true});
  }
}
